// Property Fee 物业费页面翻译
export default {
  // 页面标题
  'pages.property-fee.title': '物业费',
  'pages.property-fee.subtitle': '管理小区物业费账单的生成、缴费和查询',
  'pages.property-fee.currentSelection': '当前选择：',

  // 面包屑导航
  'pages.breadcrumb.chargeManagement': '收费管理',
  'pages.breadcrumb.propertyFee': '物业费',

  // 按钮
  'pages.property-fee.batchCreate': '批量生成',

  // 左侧树形选择
  'pages.property-fee.treeTitle': '楼栋楼层房屋选择',

  // 批量生成 Modal
  'pages.property-fee.batchModal.title': '批量生成物业费账单',
  'pages.property-fee.batchModal.confirm': '确认生成',
  'pages.property-fee.batchModal.cancel': '取消',
  'pages.property-fee.batchModal.periodLabel': '选择账期：',
  'pages.property-fee.batchModal.periodPlaceholder': '请选择账期',
  'pages.property-fee.batchModal.confirmTitle': '确认批量生成',
  'pages.property-fee.batchModal.confirmContent': '确定要批量生成 {period} 的物业费账单吗？',
  'pages.property-fee.batchModal.success': '成功生成 {count} 条账单',
  'pages.property-fee.batchModal.error': '批量生成失败',
  'pages.property-fee.batchModal.selectPeriodWarning': '请选择账期',

  // 提示信息
  'pages.property-fee.batchModal.hint': '💡 提示：批量生成将为所有未生成账单的房屋创建指定账期的物业费账单',
  'pages.property-fee.batchModal.hint2': '已存在的账单将不会重复生成',

  // PropertyFeeTable 表格
  'pages.property-fee.table.title': '物业费账单列表',

  // 表格列标题
  'pages.property-fee.table.columns.houseNumber': '房号',
  'pages.property-fee.table.columns.buildingName': '楼栋',
  'pages.property-fee.table.columns.floorName': '楼层',
  'pages.property-fee.table.columns.ownerName': '业主姓名',
  'pages.property-fee.table.columns.ownerPhone': '业主手机',
  'pages.property-fee.table.columns.ownerIdCard': '业主身份证',
  'pages.property-fee.table.columns.ownerEmail': '业主邮箱',
  'pages.property-fee.table.columns.period': '账期',
  'pages.property-fee.table.columns.billNo': '账单编号',
  'pages.property-fee.table.columns.propertyFee': '物业费',
  'pages.property-fee.table.columns.maintenanceFee': '维修费',
  'pages.property-fee.table.columns.otherFee': '其他费用',
  'pages.property-fee.table.columns.totalAmount': '总金额',
  'pages.property-fee.table.columns.finalAmount': '最终应付金额',
  'pages.property-fee.table.columns.status': '缴费状态',
  'pages.property-fee.table.columns.approvalStatus': '审核状态',
  'pages.property-fee.table.columns.paymentDate': '缴费时间',
  'pages.property-fee.table.columns.dueDate': '到期日期',
  'pages.property-fee.table.columns.operations': '操作',

  // 操作按钮
  'pages.property-fee.table.actions.view': '查看',
  'pages.property-fee.table.actions.edit': '编辑',
  'pages.property-fee.table.actions.delete': '删除',
  'pages.property-fee.table.actions.cancel': '取消',
  'pages.property-fee.table.actions.submitAudit': '提交审核',
  'pages.property-fee.table.actions.batchDelete': '批量删除',
  'pages.property-fee.table.actions.createBill': '新建账单',

  // 状态选项
  'pages.property-fee.status.unpaid': '未缴费',
  'pages.property-fee.status.paid': '已缴费',
  'pages.property-fee.status.overdue': '逾期',
  'pages.property-fee.status.partial': '部分缴费',
  'pages.property-fee.status.cancelled': '已取消',

  // 审核状态
  'pages.property-fee.approvalStatus.draft': '草稿',
  'pages.property-fee.approvalStatus.pending': '待审核',
  'pages.property-fee.approvalStatus.approved': '已通过',
  'pages.property-fee.approvalStatus.rejected': '已拒绝',
  'pages.property-fee.approvalStatus.notified': '已通知',
  'pages.property-fee.approvalStatus.overdue': '逾期',
  'pages.property-fee.approvalStatus.cancelled': '已取消',

  // 账单周期
  'pages.property-fee.billingCycle.monthly': '月付',
  'pages.property-fee.billingCycle.quarterly': '季付',
  'pages.property-fee.billingCycle.semi_annual': '半年付',
  'pages.property-fee.billingCycle.yearly': '年付',

  // 删除确认
  'pages.property-fee.table.delete.confirm.title': '确认删除',
  'pages.property-fee.table.delete.confirm.content': '确定要删除这条物业费账单吗？此操作不可撤销。',
  'pages.property-fee.table.delete.success': '删除成功',
  'pages.property-fee.table.delete.error': '删除失败',

  // 批量删除
  'pages.property-fee.table.batchDelete.confirm.title': '确认批量删除',
  'pages.property-fee.table.batchDelete.confirm.content': '确定要删除选中的 {count} 条物业费账单吗？此操作不可撤销。',
  'pages.property-fee.table.batchDelete.confirm.contentSimple': '确定要删除选中的 {count} 条记录吗？',
  'pages.property-fee.table.batchDelete.success': '批量删除成功',
  'pages.property-fee.table.batchDelete.error': '批量删除失败',
  'pages.property-fee.table.batchDelete.noSelection': '请先选择要删除的账单',

  // 提交审核
  'pages.property-fee.table.auditModal.title': '提交审核',
  'pages.property-fee.table.auditModal.submit': '提交审核',
  'pages.property-fee.table.auditModal.auditName': '审核名称',
  'pages.property-fee.table.auditModal.submitRemark': '提交说明',
  'pages.property-fee.table.auditModal.auditNamePlaceholder': '请输入审核名称',
  'pages.property-fee.table.auditModal.submitRemarkPlaceholder': '请输入提交说明（可选）',
  'pages.property-fee.table.auditModal.auditNameRequired': '请输入审核名称',
  'pages.property-fee.table.auditModal.submitRemarkRequired': '请输入提交说明',
  'pages.property-fee.table.auditModal.success': '提交审核成功',
  'pages.property-fee.table.auditModal.error': '提交审核失败',
  'pages.property-fee.table.auditModal.noSelection': '请先选择要提交审核的账单',
  'pages.property-fee.table.auditModal.selectedBills': '选中的账单列表（共 {count} 条）',

  // 审核表格列标题
  'pages.property-fee.table.auditModal.columns.billNo': '账单编号',
  'pages.property-fee.table.auditModal.columns.houseNumber': '房号',
  'pages.property-fee.table.auditModal.columns.period': '账期',
  'pages.property-fee.table.auditModal.columns.totalAmount': '总金额',
  'pages.property-fee.table.auditModal.columns.status': '缴费状态',

  // 详情弹窗
  'pages.property-fee.table.detail.title': '物业费账单详情',
  'pages.property-fee.table.detail.close': '关闭',

  // 详情区块标题
  'pages.property-fee.table.detail.basicInfo': '基本信息',
  'pages.property-fee.table.detail.houseOwnerInfo': '房屋与业主信息',
  'pages.property-fee.table.detail.feeInfo': '费用信息',
  'pages.property-fee.table.detail.paymentInfo': '缴费信息',
  'pages.property-fee.table.detail.systemInfo': '系统信息',
  'pages.property-fee.table.detail.auditRecords': '审核记录',

  // 详情字段标签
  'pages.property-fee.table.detail.labels.billNo': '账单编号',
  'pages.property-fee.table.detail.labels.period': '账期',
  'pages.property-fee.table.detail.labels.status': '缴费状态',
  'pages.property-fee.table.detail.labels.approvalStatus': '审核状态',
  'pages.property-fee.table.detail.labels.startDate': '开始日期',
  'pages.property-fee.table.detail.labels.endDate': '结束日期',
  'pages.property-fee.table.detail.labels.houseInfo': '房屋信息',
  'pages.property-fee.table.detail.labels.ownerInfo': '业主信息',
  'pages.property-fee.table.detail.labels.propertyFee': '物业费',
  'pages.property-fee.table.detail.labels.maintenanceFee': '维修基金',
  'pages.property-fee.table.detail.labels.otherFee': '其他费用',
  'pages.property-fee.table.detail.labels.lateFee': '滞纳金',
  'pages.property-fee.table.detail.labels.discountAmount': '优惠金额',
  'pages.property-fee.table.detail.labels.finalAmount': '最终金额',
  'pages.property-fee.table.detail.labels.paymentMethod': '支付方式',
  'pages.property-fee.table.detail.labels.paymentReference': '支付凭证号',
  'pages.property-fee.table.detail.labels.dueDate': '到期日期',
  'pages.property-fee.table.detail.labels.paymentDate': '缴费日期',
  'pages.property-fee.table.detail.labels.createTime': '创建时间',
  'pages.property-fee.table.detail.labels.updateTime': '更新时间',
  'pages.property-fee.table.detail.labels.remark': '备注',
  'pages.property-fee.table.detail.labels.ownerId': '业主ID',
  'pages.property-fee.table.detail.labels.idCard': '身份证',
  'pages.property-fee.table.detail.labels.email': '邮箱',

  // PropertyFeeForm 表单
  'pages.property-fee.form.editTitle': '编辑物业费账单',
  'pages.property-fee.form.createTitle': '新建物业费账单',
  'pages.property-fee.form.basicInfo': '基本信息',
  'pages.property-fee.form.houseOwnerInfo': '房屋与业主信息',
  'pages.property-fee.form.feeInfo': '费用信息',
  'pages.property-fee.form.remarks': '备注信息',
  'pages.property-fee.form.submit': '提交',
  'pages.property-fee.form.reset': '重置',

  // 表单字段标签
  'pages.property-fee.form.fields.billNo': '账单编号',
  'pages.property-fee.form.fields.status': '缴费状态',
  'pages.property-fee.form.fields.period': '账期',
  'pages.property-fee.form.fields.startDate': '开始日期',
  'pages.property-fee.form.fields.endDate': '结束日期',
  'pages.property-fee.form.fields.building': '楼栋',
  'pages.property-fee.form.fields.floor': '楼层',
  'pages.property-fee.form.fields.house': '房屋',
  'pages.property-fee.form.fields.ownerName': '业主姓名',
  'pages.property-fee.form.fields.ownerPhone': '业主手机',
  'pages.property-fee.form.fields.ownerIdCard': '业主身份证',
  'pages.property-fee.form.fields.ownerEmail': '业主邮箱',
  'pages.property-fee.form.fields.propertyFee': '基础物业费',
  'pages.property-fee.form.fields.maintenanceFee': '维修基金',
  'pages.property-fee.form.fields.otherFee': '其他费用',
  'pages.property-fee.form.fields.lateFee': '滞纳金',
  'pages.property-fee.form.fields.discountAmount': '优惠金额',
  'pages.property-fee.form.fields.finalAmount': '最终金额',
  'pages.property-fee.form.fields.remark': '备注',

  // 表单占位符
  'pages.property-fee.form.placeholder.period': '如：2024-01',
  'pages.property-fee.form.placeholder.startDate': '请选择开始日期',
  'pages.property-fee.form.placeholder.endDate': '请选择结束日期',
  'pages.property-fee.form.placeholder.building': '请选择楼栋',
  'pages.property-fee.form.placeholder.floor': '请选择楼层',
  'pages.property-fee.form.placeholder.house': '请选择房屋',
  'pages.property-fee.form.placeholder.ownerName': '请输入业主姓名',
  'pages.property-fee.form.placeholder.ownerPhone': '请输入业主手机',
  'pages.property-fee.form.placeholder.ownerIdCard': '请输入业主身份证',
  'pages.property-fee.form.placeholder.ownerEmail': '请输入业主邮箱',
  'pages.property-fee.form.placeholder.propertyFee': '请输入物业费金额',
  'pages.property-fee.form.placeholder.maintenanceFee': '请输入维修费金额',
  'pages.property-fee.form.placeholder.otherFee': '请输入其他费用',
  'pages.property-fee.form.placeholder.discountAmount': '请输入优惠金额',
  'pages.property-fee.form.placeholder.finalAmount': '请输入最终应付金额',
  'pages.property-fee.form.placeholder.remark': '请输入备注信息',

  // 表单验证消息
  'pages.property-fee.form.validation.periodRequired': '请输入账期',
  'pages.property-fee.form.validation.startDateRequired': '请选择开始日期',
  'pages.property-fee.form.validation.endDateRequired': '请选择结束日期',
  'pages.property-fee.form.validation.buildingRequired': '请选择楼栋',
  'pages.property-fee.form.validation.floorRequired': '请选择楼层',
  'pages.property-fee.form.validation.houseRequired': '请选择房屋',
  'pages.property-fee.form.validation.propertyFeeRequired': '请输入基础物业费',
  'pages.property-fee.form.validation.finalAmountRequired': '总金额将自动计算',
  'pages.property-fee.form.validation.remarkMaxLength': '备注长度不能超过500个字符',
  'pages.property-fee.form.validation.loadPriceConfigFailed': '加载价格配置失败',
  'pages.property-fee.form.validation.loadHouseInfoFailed': '加载房屋信息失败',

  // 表单提交消息
  'pages.property-fee.form.submit.success': '物业费账单保存成功',
  'pages.property-fee.form.submit.error': '保存失败，请重试',

  // 货币单位
  'pages.property-fee.currency.php': '₱',

  // HouseSelector 房屋选择器
  'pages.property-fee.houseSelector.title': '选择房屋',
  'pages.property-fee.houseSelector.confirm': '确认选择',
  'pages.property-fee.houseSelector.cancel': '取消',
  'pages.property-fee.houseSelector.selectHouseWarning': '请选择一个房屋',
  'pages.property-fee.houseSelector.treeTitle': '楼栋楼层选择',
  'pages.property-fee.houseSelector.tableTitle': '房屋列表',

  // 房屋列表表格列
  'pages.property-fee.houseSelector.columns.select': '选择',
  'pages.property-fee.houseSelector.columns.floor': '楼层',
  'pages.property-fee.houseSelector.columns.houseNumber': '房号',
  'pages.property-fee.houseSelector.columns.ownerName': '业主姓名',
  'pages.property-fee.houseSelector.columns.ownerPhone': '业主电话',

  // 分页信息
  'pages.property-fee.table.pagination.showTotal': '第 {start}-{end} 条/总共 {total} 条',

  // 审核记录
  'pages.property-fee.table.detail.audit.loading': '加载中...',
  'pages.property-fee.table.detail.audit.noRecords': '暂无审核记录',

  // 审核名称模板
  'pages.property-fee.table.auditModal.defaultNameTemplate': '{period} 物业费账单 ({count}笔)',

  // 详情标签
  'pages.property-fee.table.detail.labels.idCardPrefix': '身份证:',
  'pages.property-fee.table.detail.labels.emailPrefix': '邮箱:',
  'pages.property-fee.table.detail.labels.ownerIdPrefix': '业主ID:',
};
